import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_removing_upgrades~1
			upgrade: {
				routeName: null,
			},
		},
		'activity-male-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_removing_upgrades~1
			upgrade: {
				routeName: null,
			},
		},
		male: {
			// ?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_removing_upgrades~1
			upgrade: {
				routeName: null,
			},
		},
	},
]

export default config
